<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getAllInvoices } from "../../../api/services/invoice.service";

/**
 * Manage Invoices Page
 */
export default {
	page: {
		title: "Rechungen Verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
	},
	data() {
		return {
			title: this.$i18n.t("invoice.header.title"),
			items: [
				{
					text: this.$i18n.t("invoice.header.item"),
					active: true,
				},
			],
			allInvoices: null,
			dataForTable: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: "number",
			sortDesc: false,
			fields: [
				{
					key: "number",
					label: "#",
					sortable: false,
				},
				{
					key: "invoiceNumber",
					label: this.$i18n.t("invoice.table.invoiceNumber"),
					sortable: true,
				},
				{
					key: "billingName",
					label: this.$i18n.t("invoice.table.billingName"),
					sortable: false,
				},
				{
					key: "billingEmail",
					label: this.$i18n.t("invoice.table.billingEmail"),
					sortable: false,
				},
				{
					key: "invoiceDate",
					label: this.$i18n.t("invoice.table.date"),
					sortable: false,
				},
				{
					key: "amount",
					label: this.$i18n.t("invoice.table.value"),
					sortable: true,
				},
				{
					key: "invoiceS3URL",
					label: "",
					sortable: false,
				},
				{
					key: "status",
					label: this.$i18n.t("invoice.table.status"),
					sortable: true,
					thClass: "d-none",
					tdClass: "d-none",
				},
			],
		};
	},
	computed: {
		rows() {
			return this.dataForTable.length;
		},
	},
	async mounted() {
		this.totalRows = this.items.length;
		await this.getAllInvoices();
	},
	methods: {
		async getAllInvoices() {
			let allInvoicesFromDatabase = await getAllInvoices();
			this.allInvoices = allInvoicesFromDatabase;

			for (let i = 0; i < this.allInvoices.length; i++) {
				let invoice_push = {
					number: 0,
					invoiceNumber: "RE-1000",
					billingName: "",
					billingEmail: "",
					billingAddress: "",
					invoiceDate: "2020-02-20",
					amount: 0,
					invoiceS3URL: "",
					status: "",
				};

				invoice_push.number = i + 1;
				invoice_push.billingName = this.allInvoices[i].billingName;
				invoice_push.billingEmail = this.allInvoices[i].billingEmail;
				invoice_push.billingAddress = this.allInvoices[i].billingAddress;
				invoice_push.amount = this.allInvoices[i].price;
				invoice_push.invoiceDate = this.allInvoices[i].createdAt.slice(0, 10);
				invoice_push.invoiceNumber = this.allInvoices[i].invoiceNumber;
				invoice_push.invoiceS3URL = this.allInvoices[i].invoiceS3URL;
				invoice_push.status = this.allInvoices[i].status;
				this.dataForTable.push(invoice_push);
			}
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="row mt-2 mb-4">
							<div class="col-sm-12 col-md-6">
								<div id="tickets-table_length" class="dataTables_length">
									<label class="d-inline-flex align-items-center">
										Anzeigen&nbsp;
										<b-form-select
											v-model="perPage"
											size="sm"
											:options="pageOptions"
										></b-form-select
										>&nbsp;Einträge
									</label>
								</div>
							</div>
							<!-- Search -->
							<div class="col-sm-12 col-md-6">
								<div
									id="tickets-table_filter"
									class="dataTables_filter text-md-right"
								>
									<label class="d-inline-flex align-items-center">
										Suchen:
										<b-form-input
											v-model="filter"
											type="search"
											placeholder="Suchen..."
											class="form-control form-control-sm ml-2"
										></b-form-input>
									</label>
								</div>
							</div>
							<!-- End search -->
						</div>
						<!-- Table -->
						<div class="table-responsive mb-0">
							<b-table
								:items="dataForTable"
								:fields="fields"
								responsive="sm"
								:per-page="perPage"
								:current-page="currentPage"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
								:filter="filter"
								:filter-included-fields="filterOn"
								@filtered="onFiltered"
							>
								<template v-slot:cell(amount)="data">
									<small> EUR </small> {{ data.value.toLocaleString("de") }}
								</template>
								<template v-slot:cell(invoiceS3URL)="scope">
									<div class="text-right">
										<a
											:href="scope.item.invoiceS3URL"
											target="_blank"
											v-if="scope.item.status !== 'CANCELLED'"
											><b-button variant="success" size="sm"
												><i class="bx bxs-download"></i
											></b-button>
										</a>
										<p class="red-label" v-else>ABGESAGT</p>
									</div>
								</template></b-table
							>
						</div>
						<div class="row">
							<div class="col">
								<div
									class="dataTables_paginate paging_simple_numbers float-right"
								>
									<ul class="pagination pagination-rounded mb-0">
										<!-- pagination -->
										<b-pagination
											v-model="currentPage"
											:total-rows="rows"
											:per-page="perPage"
										></b-pagination>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end row -->
	</Layout>
</template>
